import React from 'react';
import background from '../../assets/jellyfish.jpg';
import ReusableInfoCard from '../../components/ReusableInfoCard/ReusableInfoCard';


class InfoJellyfish extends React.Component {
  render () { 
   return(
  
  <ReusableInfoCard             
    
        tag="OCEANS"
        subtag="OVERPOPULATED"
        description="Jellyfish"
        paragraph="Jellyfish are simple invertebrates which prey on small fish by using a venemous nettle. An elementary nervous system allows them to respond to light and smell, though movement is heavily influenced by the currents."
        background={background}
     />
  
  );
 }
}   

export default InfoJellyfish;